<template>
  <div class="">
    <div class="tab-content">
      <!-- <pre>{{ formParam }}</pre> -->
      <div
        :class="tabMessage == 'setup' ? 'tab-pane show active' : 'tab-pane'"
        id="form"
      >
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>
                            Title:
                            <span class="text-danger">*</span>
                          </label>
                          <input
                            v-model="formParam.header.title"
                            placeholder="Type title..."
                            type="text"
                            class="form-control"
                          />
                        </div>
                      </div>
                      <div class="col-sm-12 col-md-12">
                        <div class="form-group">
                          <label>
                            Respond Message:
                            <span class="text-danger">*</span>
                          </label>
                          <!-- {{broadcastParam}} -->
                          <chatComponent v-model="formParam.header.message" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>Attach Image/File</label>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="onoffswitch">
                        <input
                          @click="updateMessageTypeCurrent('')"
                          type="checkbox"
                          name="onoffswitch"
                          v-model="formParam.header.is_enable_attach_file"
                          class="onoffswitch-checkbox"
                          id="is_enable_attach_file"
                        />
                        <label
                          class="onoffswitch-label"
                          for="is_enable_attach_file"
                        >
                          <span class="onoffswitch-inner"></span>
                          <span class="onoffswitch-switch"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="col-md-12"
                v-if="formParam.header.is_enable_attach_file == true"
              >
                <div class="form-group">
                  <table class="table table-active">
                    <tr>
                      <th class="text-right">Url File</th>
                      <th style="width: 30%" class="text-left">
                        <div class="onoffswitch">
                          <input
                            type="checkbox"
                            name="onoffswitch"
                            class="onoffswitch-checkbox"
                            v-model="formParam.header.is_custom_url"
                            id="switch_url_file"
                          />
                          <label
                            class="onoffswitch-label"
                            for="switch_url_file"
                          >
                            <span class="onoffswitch-inner"></span>
                            <span class="onoffswitch-switch"></span>
                          </label>
                        </div>
                      </th>
                      <th class="text-center">
                        <label>Select Message Type &amp; Upload File</label>
                        <p
                          v-if="
                            formParam.header != '' &&
                            formParam.header.image_url != ''
                          "
                        >
                          <a
                            v-if="formParam.header.message_type == 'document'"
                            target="_blank"
                            :href="formParam.header.image_url"
                          >
                            <i class="fa fa-file"></i> File
                          </a>
                          <a
                            v-if="formParam.header.message_type == 'image'"
                            target="_blank"
                            :href="formParam.header.image_url"
                          >
                            <img
                              :src="formParam.header.image_url"
                              style="width: 100px"
                            />
                          </a>
                        </p>
                        <button
                          class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          v-if="uploadMessageType == ''"
                        >
                          Options
                        </button>
                        <button
                          :style="'margin:5px;'"
                          class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          v-else
                        >
                          {{ uploadMessageType }}
                        </button>
                        <div class="dropdown-menu">
                          <a
                            @click.prevent="updateMessageTypeCurrent(opt)"
                            class="dropdown-item"
                            href="#"
                            v-for="(opt, index) in messageTypeOptionsUpload"
                            :key="index"
                          >
                            <i
                              class="text-success fa fa-check-circle"
                              v-if="uploadMessageType == opt"
                            ></i>
                            {{ opt }}
                          </a>
                        </div>
                      </th>
                    </tr>
                  </table>

                  <div
                    v-show="
                      files.length == 0 &&
                      (formParam.header.is_custom_url == false ||
                        typeof formParam.header.is_custom_url == 'undefined')
                    "
                    class="col-md-12 upload-drop-zone"
                    id="drop-zone"
                  >
                    <center>
                      <i class="fa fa-cloud-upload fa-2x"></i>
                      <span class="upload-text">
                        <label :for="name">
                          Just drag and drop file here
                        </label>
                      </span>
                    </center>
                  </div>
                  <div>
                    <!-- <form id="js-upload-form"> -->

                    <div
                      class="col-md-12"
                      v-if="formParam.header.is_custom_url == true"
                    >
                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group">
                            <label>Image / File URL</label>
                            <input
                              type="text"
                              class="form-control"
                              v-model="formParam.header.image_url"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="col-md-12"
                      v-if="formParam.header.is_custom_url == false"
                    >
                      <!-- {{files}} -->
                      <!-- <h4 v-if="files.length">Uploading</h4> -->
                      <ul class="upload-list" v-if="files.length">
                        <li
                          v-for="file in files"
                          :key="file.id"
                          class="file-list"
                        >
                          <div class="upload-wrap">
                            <div class="file-name">
                              <!-- <i class="fa fa-photo"></i> -->
                              <img
                                style="width: 30px"
                                v-if="file.thumb"
                                :src="file.thumb"
                              />
                              {{ file.name }}
                            </div>
                            <div class="file-size">
                              {{ formatSizes(file.size) }}
                            </div>
                            <div class="file-close">
                              <span class="text-danger" v-if="file.error">{{
                                file.error
                              }}</span>
                              <span v-else-if="file.success">
                                <i class="text-success fa fa-check-circle"></i>
                              </span>
                              <span v-else-if="file.active">active</span>
                              <span v-else></span>

                              <a
                                href="#"
                                @click.prevent="$refs.uploadbc.remove(file)"
                                class="text-warning"
                              >
                                <i class="fa fa-trash-o"></i>
                              </a>
                            </div>
                          </div>

                          <div
                            class="progress progress-xs progress-striped"
                            v-if="file.active || file.progress !== '0.00'"
                          >
                            <div
                              class="progress-bar bg-success"
                              role="progressbar"
                              :style="{ width: file.progress + '%' }"
                            ></div>
                          </div>
                          <div
                            class="upload-process"
                            v-if="file.active || file.progress !== '0.00'"
                          >
                            {{ file.progress }}% done
                          </div>
                        </li>
                      </ul>
                    </div>
                    <!-- </form> -->

                    <div class="col-sm-12 col-md-12">
                      <div class="alert alert-info">
                        <ul
                          style="
                            overflow-x: scroll;
                            overflow-y: hidden;
                            white-space: nowrap;
                          "
                        >
                          <li class="text-wrap">
                            Support files: {{ extensions }}
                          </li>
                          <li>MaxSize: 10Mb</li>
                        </ul>
                      </div>
                    </div>
                    <div
                      class="col-sm-12"
                      v-show="
                        $refs.uploadbc &&
                        $refs.uploadbc.active == false &&
                        formParam.header.is_custom_url == false
                      "
                    >
                      <div class="submit-section">
                        <div class="input-group mb-3">
                          <div class="input-group-prepend" v-show="false">
                            <file-upload-bc
                              :add-index="true"
                              class="btn btn-outline-secondary"
                              :data="objFilesMessageHandler"
                              :post-action="uploadUrl"
                              :multiple="false"
                              :headers="headers"
                              :drop="true"
                              :drop-directory="true"
                              v-model="files"
                              @input-filter="inputFilter"
                              @input-file="inputFile"
                              ref="uploadbc"
                              :maximum="maximumUpload"
                              :extensions="extensions"
                            >
                              <img src="@/assets/attachment.png" alt />
                            </file-upload-bc>
                          </div>

                          <div class="input-group-append">
                            <button
                              v-if="false"
                              @click.prevent="$refs.uploadbc.active = true"
                              class="btn btn-outline-secondary"
                              type="button"
                            >
                              Upload File
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      class="row"
                      v-if="$refs.uploadbc && $refs.uploadbc.active == true"
                    >
                      <div class="col-sm-2">
                        <Skeleton :height="'40px'" :count="1" />
                      </div>
                      <div class="col-sm-2">
                        <Skeleton :height="'40px'" :count="1" />
                      </div>
                      <div class="col-sm-6">
                        <Skeleton :height="'40px'" :count="1" />
                      </div>
                      <div class="col-sm-2">
                        <Skeleton :height="'40px'" :count="1" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label>
                    Tags (Chat/CRM):
                    <br /><small>Misal: #Urgent, #NeedToBeReplied, ...</small>
                  </label>
                  <tags-assign />
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label>
                    Notif ke :
                    <br /><small
                      >Notifikasi ke nomor Whatsapp saat Text Reply
                      dipilih</small
                    >
                  </label>
                  <tags-assign-notif :textReplyId:="''" :isNotifTextReply="1" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        :class="tabMessage == 'preview' ? 'tab-pane show active' : 'tab-pane'"
        id="preview"
        :style="'background: url(\'' + whatsappBackground + '\');'"
      >
        <preview-message :buttonsRows="buttonsRows" :linkRows="linkRows" />
      </div>
    </div>

    <div class="submit-section">
      <div class="row">
        <div class="col-md-12" style="margin-bottom: 10px">
          <ul class="nav nav-tabs nav-tabs-bottom nav-justified">
            <li class="nav-item">
              <a
                @click="settabMessage('setup')"
                :class="tabMessage == 'setup' ? 'nav-link active' : 'nav-link'"
                href="#form"
                data-toggle="tab"
                >Setup Message</a
              >
            </li>
            <!-- <li class="nav-item">
                    <a
                      @click="savePreview();settabMessage('preview')"
                      :class="(tabMessage=='preview')?'nav-link active':'nav-link' "
                      href="#preview"
                      data-toggle="tab"
                    >Preview Message</a>
                  </li> -->
          </ul>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <center v-if="isSending == false">
              <!-- {{isSending}} -->
              <button
                @click="saveForm(0, 1)"
                class="btn btn-md btn-warning"
                type="button"
              >
                <i class="fa fa-save"></i> Draft
              </button>

              <button
                @click.prevent="saveForm(0, 0)"
                class="btn btn-md btn-success"
                type="button"
                :style="'margin-left:10px;'"
              >
                <i class="fa fa-check"></i> Publish
              </button>
            </center>
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <center v-if="isSending == false">
              <button
                @click.prevent="saveForm(1, 0)"
                class="btn btn-lg btn-info"
                type="button"
              >
                <i class="fa fa-check"></i> Publish &amp; Close
              </button>
            </center>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { APICore, APICoreV2 } from "@/utils/servicesApi";
import { getXAuthAgent, getXAuthToken, getAgentSession } from "@/utils/auth";

import { Skeleton } from "vue-loading-skeleton";
import { mapGetters } from "vuex";
import FileUpload from "vue-upload-component";
import Cropper from "cropperjs";
import ImageCompressor from "@xkeshi/image-compressor";
import { VueChatEmoji, emojis } from "vue-chat-emoji";
require("vue-chat-emoji/dist/vue-chat-emoji.min.css");
import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css");
import { Datetime } from "vue-datetime";
// You need a specific loader for CSS files
import "vue-datetime/dist/vue-datetime.css";
import TagsAssign from "@/views/automation/textReply/components/tagsAssign.vue";
import TagsAssignNotif from "@/views/automation/textReply/components/tagsAssignNotif.vue";

import PreviewMessage from "@/views/automation/textReply/preview.vue";
import {
  formatDate,
  formatDateForMessage,
  getWhatsappNumberFromJid,
  formatSizes,
  currentDateTimeUTC,
} from "@/utils/helper";
export default {
  name:'formTextReply',
  components: {
    Skeleton,
    FileUploadBc: FileUpload,
    Emoji: VueChatEmoji,
    Multiselect,
    Datetime,
    PreviewMessage,
    TagsAssign,
    TagsAssignNotif,
  },
  props: {
    searchData: {
      type: Function,
    },
  },
  data() {
    return {
      interactiveMessageType: [
        // { id: "button", label: "Button" },
        { id: "link", label: "Link/Call" },
        // { id: "list_text", label: "List" }
      ],
      tabMessage: "setup", //setup or preview
      whatsappBackground: process.env.VUE_APP_WHATSAPP_BACKGROUND,
      objFilesMessageHandler: {
        file: null,
        // message_media: messaegMedia,
        message_type: "",
      },
      messageTypeOptionsSupport: ["text only", "media"],
      uploadMessageSupportSelected: "text only",
      messageTypeOptionsUpload: ["image", "document"],
      uploadMessageType: "image",
      caption: "",
      name: "file",
      thumbUpload: [],
      uploadAuto: true,
      uploadUrl:
        // process.env.VUE_APP_BASE_API + this.APICore() + "/omni/room/send-file",
        process.env.VUE_APP_BASE_API +
        this.APICore() +
        "/omni/only-upload-filev2",
      maximumUpload: 1,
      accept: "image/jfif,image/png,image/gif,image/jpeg,image/webp",
      extensions: "jfif, gif,jpg,jpeg,png,webp,zip,pdf,xls,xlsx, doc, docx",
      minSize: 1024,
      size: 1024 * 1024 * 10,
      files: [],
      buttonsLoading: false,
      linkParams: {
        columnFilters: {
          button_title: "",
          button_text: "",
          button_response: "",
        },
        page: 1,
        perPage: 500, // perPage
      },
      buttonsParams: {
        columnFilters: {
          button_title: "",
          button_text: "",
          button_response: "",
        },
        page: 1,
        perPage: 500, // perPage
      },
      buttonsRows: [],
      linkRows: [],
      selectedLicense: [],
      licenseOptions: [],
      licenseListParam: {
        id: "",
        license_name: "",
        license_phone_number: "",
        license_status: "",
        page: 0,
        perPage: 20,
      },
      isLoadingLicense: false,
      emojiAttr2: {
        open: false,
        width: "0%",
        height: "0px",
      },
      emojiAttr: {
        open: false,
        width: "0%",
        height: "0px",
      },
      templateMessage: [
        "${first_name}",
        "${last_name}",
        "${phone_number}",
        "${email}",
        "${month_current}",
        "${month_current_name}",
        "${year_current}",
        "${today}",
        "${yesterday}",
        "${month_ago}",
        "${month_ago_name}",
        "${year_ago}",
      ],
      isSending: false,
      defaultDetailButton: 10,
      defaultDetailListText: 10, //max 10
      formParam: {
        header: {
          id: "",
          title: "",
          message: "",
          is_enable_attach_file: false,
          footer_message: "",
          footer_message_status: false,
          is_custom_url: false,
          image_url: "",
          message_type: "text",
          tag_id: JSON.stringify([]),
          tag_id_notif: JSON.stringify([]), //phone number
          // button_type: "link",
          // button_type_away_message: "link"
        },
      },
      isLoading: false,
    };
  },
  watch: {  
  },
  computed: {
    headers() {
      return {
        "X-Auth-Token": "Bearer " + this.getXAuthToken(),
        // "X-Auth-Agent": "Bearer " + this.getXAuthAgent()
      };
    },
    ...mapGetters(["agentSession"]),
    // formParamTRSt() {
    //   return this.$store.state.automation.formParamTRSt;
    // },
    // isShowForm() {
    //   return this.$store.state.automation.isShowForm;
    // },
  },
  methods: {
    settabMessage(value) {
      this.tabMessage = value;
    },
    addRow() {
      let newRow = {
        select_variable: "conversation",
        condition: "",
        text: "",
      };
      this.formParam.detail_some.push(newRow);
    },
    removeRow(removeIndex, maxIndex) {
      // console.log("removeIndex", removeIndex, maxIndex);
      if (removeIndex == 0 && maxIndex == 0) {
        return;
      }

      if (removeIndex > -1) {
        // only splice array when item is found
        this.formParam.detail_some.splice(removeIndex, 1); // 2nd parameter means remove one item only
      }
    },
    async loadReplyButtons() {
      this.buttonsLoading = await true;
      this.buttonsParams.page = 0;
      await this.$store
        .dispatch("automation/listReplyButtons", this.buttonsParams) // sesuai kan dengan method di API
        .then((response) => {
          const { data } = response;
          this.buttonsRows = data.data;
          this.buttonsLoading = false;
        })
        .catch((error) => {
          this.buttonsLoading = false;
          console.log(error);
        });
    },
    async loadReplyLink() {
      this.buttonsLoading = await true;
      this.linkParams.page = 0;
      await this.$store
        .dispatch("automation/listReplyLink", this.linkParams) // sesuai kan dengan method di API
        .then((response) => {
          const { data } = response;
          this.linkRows = data.data;
          this.buttonsLoading = false;
        })
        .catch((error) => {
          this.buttonsLoading = false;
          console.log(error);
        });
    },
    resetDetailButton() {},

    addTemplateToMesage(template) {
      this.formParam.header.message += template;
    },
    addTemplateToMesage2(template) {
      this.formParam.header.message_away += template;
    },
    currentDateTimeUTC() {
      return currentDateTimeUTC();
    },
    async savePreview() {
      this.formParam.header.message = await this.remove_tags(
        this.formParam.header.message
      );

      await this.$store.dispatch("automation/actFormParamTRSt", this.formParam);
    },
    updateTag(tagIdArr) {
      // console.log("from Parent: ", tagIdArr)
      let parTagId = [];
      tagIdArr.forEach((row, idx) => {
        parTagId.push(row.id);
      });
      this.formParam.header.tag_id = JSON.stringify(parTagId);
    },
    updateTagNotif(tagIdArr) {
      // console.log("from Parent: ", tagIdArr)
      let parTagId = [];
      tagIdArr.forEach((row, idx) => {
        parTagId.push(row.id);
      });
      this.formParam.header.tag_id_notif = JSON.stringify(parTagId);
    },
    async saveForm(isExit = 0, isDraft = 0) {
      if (this.formParam.header.footer_message_status == false) {
        this.formParam.header.footer_message = ""; //data dihapus
      }

      if (typeof isDraft == "undefined") {
        this.formParam.header.is_publish = 1;
      } else {
        if (isDraft == 1) {
          this.formParam.header.is_publish = 0;
        } else {
          this.formParam.header.is_publish = 1;
        }
      }

      this.$fire({
        title: "Are you sure you will continue this action?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`,
      }).then(async (r) => {
        // console.log("rrrr", r);
        // return;
        if (r.value == true) {
          // console.log("valueee", r);
          this.isSending = await true;
          this.emojiToggle(false);
          this.formParam.header.message = await this.remove_tags(
            this.formParam.header.message
          );
          this.formParam.header.network_id = parseInt(
            this.formParam.header.network_id
          );
          this.formParam.header.create_datetime = parseInt(
            this.formParam.header.create_datetime
          );
          this.formParam.header.update_datetime = parseInt(
            this.formParam.header.update_datetime
          );
          await this.$store
            .dispatch("automation/storeTextReply", this.formParam)
            .then((response) => {
              // this.isSending = false;
              if (this.formParam.id == "") {
                this.formParam = {
                  header: {
                    id: "",
                    title: "",
                    message: "",
                    is_enable_attach_file: false,
                    is_custom_url: false,
                    image_url: "",
                  },
                };
              }

              this.$fire({
                title: "Success",
                text: response["msg"],
                type: "success",
                timer: 2000,
              }).then((r) => {});
              this.searchData();
              this.isSending = false;
            })
            .catch(() => {
              this.isSending = false;
            });
        }
      });
    },
    remove_tags(html) {
      var html = html.replace("<br />", "||br||");
      var tmp = document.createElement("DIV");
      tmp.innerHTML = html;
      html = tmp.textContent || tmp.innerText;
      return html.replace("||br||", "<br />");
    },
    emojiToggle(isClosed) {
      // console.log("clicked toggle");
      if (typeof isClosed == "undefined") {
        if (this.emojiAttr.open == true) {
          this.emojiAttr.open = false;
        } else {
          this.emojiAttr.open = true;
        }
      } else {
        this.emojiAttr.open = isClosed;
      }

      if (this.emojiAttr.open == true) {
        this.emojiAttr.width = "96%";
        this.emojiAttr.height = "250px";
      } else {
        this.emojiAttr.width = "0%";
        this.emojiAttr.height = "0px";
      }

      // console.log("this.emojiAttr.open:: ", this.emojiAttr.open);
    },
    selectedEmoji(args) {
      this.formParam.header.message += args.emoji;
      // console.log(args); /* return {...}*/
    },

    updateMessageSupportCurrent(msgType) {
      this.uploadMessageSupportSelected = msgType;
    },
    updateMessageTypeCurrent(msgType) {
      if (msgType == "") {
         
        if (this.formParam.header.is_enable_attach_file == true) {
          this.formParam.header.message_type = "image";
          this.uploadMessageType = this.formParam.header.message_type; 
        } else {
          this.formParam.header.message_type = "text";
        }
      } else {
        this.uploadMessageType = msgType;
        this.formParam.header.message_type = msgType;
      }
    },
    inputFileHandler(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        this.$refs.uploadbc.active = true;
      }
    },
    inputFilter(newFile, oldFile, prevent) {
      console.log("newFile, oldFile", newFile, oldFile);
      if (newFile && !oldFile) {
        // Before adding a file
        // 添加文件前
        // Filter system files or hide files
        // 过滤系统文件 和隐藏文件
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }
        // Filter php html js file
        // 过滤 php html js 文件
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent();
        }
        // Automatic compression
        // 自动压缩
        if (
          newFile.file &&
          newFile.error === "" &&
          newFile.type.substr(0, 6) === "image/" &&
          this.autoCompress > 0 &&
          this.autoCompress < newFile.size
        ) {
          // console.log("compressing", newFile, oldFile);

          newFile.error = "compressing";
          const imageCompressor = new ImageCompressor(null, {
            convertSize: 1024 * 1024,
            maxWidth: 512,
            maxHeight: 512,
          });
          imageCompressor
            .compress(newFile.file)
            .then((file) => {
              this.$refs.uploadbc.update(newFile, {
                error: "",
                file,
                size: file.size,
                type: file.type,
              });
            })
            .catch((err) => {
              this.$refs.uploadbc.update(newFile, {
                error: err.message || "compress",
              });
            });
        }
      }
      console.log("humb newFile, oldFile: ", newFile, oldFile);
      if (
        newFile &&
        newFile.error === "" &&
        newFile.file &&
        (!oldFile || newFile.file !== oldFile.file)
      ) {
        // Create a blob field
        // 创建 blob 字段
        newFile.blob = "";
        let URL = window.URL || window.webkitURL;
        if (URL) {
          newFile.blob = URL.createObjectURL(newFile.file);
        }
        // Thumbnails
        // 缩略图
        newFile.thumb = "";
        if (newFile.blob && newFile.type.substr(0, 6) === "image/") {
          newFile.thumb = newFile.blob;
        }
      }
      // image size
      // image 尺寸
      if (
        newFile &&
        newFile.error === "" &&
        newFile.type.substr(0, 6) === "image/" &&
        newFile.blob &&
        (!oldFile || newFile.blob !== oldFile.blob)
      ) {
        newFile.error = "image parsing";
        let img = new Image();
        img.onload = () => {
          this.$refs.uploadbc.update(newFile, {
            error: "",
            height: img.height,
            width: img.width,
          });
        };
        img.οnerrοr = (e) => {
          console.log("errorr", e);
          this.$refs.uploadbc.update(newFile, { error: "parsing image size" });
        };
        img.src = newFile.blob;
      }
    },
    inputFile(newFile, oldFile) {
      // console.log("inputFile:oldddd", oldFile);
      // console.log("inputFile:newf", newFile);
      if (newFile && oldFile) {
        console.log("oldddd", oldFile);
        console.log("newf", newFile);
        // update
        if (newFile.active && !oldFile.active) {
          //buildData
          let dataArr = {
            message_type: this.uploadMessageType,
          };
          // this.$store.dispatch("omniwa/actFilesMessageHandler", dataArr);
          this.objFilesMessageHandler = dataArr;
          this.$refs.uploadbc.update(newFile, { data: dataArr });

          // beforeSend
          // min size
          if (
            newFile.size >= 0 &&
            this.minSize > 0 &&
            newFile.size < this.minSize
          ) {
            this.$refs.uploadbc.update(newFile, { error: "size" });
          }
        }
        if (newFile.progress !== oldFile.progress) {
          // progress
          console.log("progress", newFile.progress);
        }
        if (newFile.error && !oldFile.error) {
          // console.log("err", newFile.error.response);
          // console.log("newFile", newFile);
          this.$refs.uploadbc.update(newFile, { progress: 0 });

          // error
          this.$fire({
            title: "Error",
            text: newFile.response.msg,
            type: "error",
            timer: 1000,
          }).then((r) => {});
        }
        if (newFile.success && !oldFile.success) {
          this.formParam.header.image_url = newFile.response.data.url;
          this.caption = "";
          this.thumbUpload.push(newFile.thumb);
          // success
          // console.log("this.thumbUpload", this.thumbUpload);
          console.log("success", newFile.success, newFile);
        }
      }
      if (!newFile && oldFile) {
        this.formParam.header.image_url = "";
        // remove
        if (oldFile.success && oldFile.response.id) {
        }
      }
      // Automatically activate upload
      if (
        Boolean(newFile) !== Boolean(oldFile) ||
        oldFile.error !== newFile.error
      ) {
        if (this.uploadAuto && !this.$refs.uploadbc.active) {
          this.$refs.uploadbc.active = true;
        }
      }
    },
    formatSizes(bytes) {
      return formatSizes(bytes);
    },
    getExt(filename) {
      return filename.split(".").pop();
    },
    getXAuthToken() {
      return getXAuthToken();
    },
    getXAuthAgent() {
      return getXAuthAgent();
    },
    getWhatsappNumberFromJid(jid) {
      return getWhatsappNumberFromJid(jid);
    },
    APICoreV2() {
      return APICoreV2();
    },
    APICore() {
      return APICore();
    },
  },
  async created() {
    this.$root.$on("updateTag", async (tagIdArr) => {
      this.updateTag(tagIdArr);
    });
    this.$root.$on("updateTagNotif", async (tagIdArr) => {
      this.updateTagNotif(tagIdArr);
    });
  },
  beforeDestroy() {
    this.$root.$off("updateTag");
    this.$root.$off("updateTagNotif");
  },
  mounted() {
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left",
        },
      });
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function (e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "buttons-add",
};
</script>


// WEBPACK FOOTER //
// src/components/TextReply/formTextReply.vue